export function addSubcomponents(subs, parent) {
    var assigned = parent;
    Object.keys(subs).forEach(function (key) {
        assigned[key] = subs[key];
    });
    return assigned;
}
//# sourceMappingURL=addSubcomponents.js.map